import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@nest/uikit-react';
import { useState } from 'react';
export function PdfPreviewDialog({ objectUrl, onClose }) {
    const [open, setOpen] = useState(true);
    const handleOpenChange = (value) => {
        if (!value) {
            setOpen(false);
            onClose();
        }
    };
    return (_jsx(Dialog, { open: open, onOpenChange: handleOpenChange, children: _jsxs(DialogContent, { className: "w-[80vw] p-0 sm:max-w-full", children: [_jsx(DialogHeader, { className: "p-4", children: _jsx(DialogTitle, { children: "N\u00E1hled" }) }), _jsx("iframe", { src: objectUrl, title: "PDF Preview", className: "w-full h-[80vh]" })] }) }));
}
//# sourceMappingURL=PdfPreviewDialog.js.map